// extracted by mini-css-extract-plugin
export default {"section-p":"Section_section-p__sdXun","section":"Section_section__OkV+i","dark":"Section_dark__Sdaoh","section-email":"Section_section-email__6ONdn"};